import { useTranslation } from "react-i18next";
import { ExternalLinkIcon } from "@heroicons/react/outline";
import { useFormikContext } from "formik";
import { FlowData } from "@hilos/types/flow";
import AvailableFlowSelector from "src/components/AvailableFlowSelector";
import { buildRoute } from "src/router/router";

interface FlowBuilderStepTriggerFlowProps {
  index: number;
}

function FlowBuilderStepTriggerFlow({
  index,
}: FlowBuilderStepTriggerFlowProps) {
  const [t] = useTranslation();

  const { values } = useFormikContext<FlowData>();
  const flowId = values.steps[index].next_flow;

  const openFlowInNewTab = () => {
    if (!flowId) return;
    const flowUrl = buildRoute("flow-detail", {
      id: flowId,
    });

    window.open(flowUrl, "_blank");
  };

  return (
    <div className="space-y-4">
      <AvailableFlowSelector
        name={`steps.${index}.next_flow`}
        label={t("flows:steps.trigger-flow.label", "Next flow")}
        help={t("flows:steps.trigger-flow.help", "Select the flow to start.")}
        placeholder={t("type-to-search")}
      />

      {flowId && (
        <button
          type="button"
          onClick={openFlowInNewTab}
          className="inline-flex rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:bg-gray-300 disabled:text-gray-100"
        >
          {t("flows:trigger-flow.open-flow", "Open flow in new tab")}
          <ExternalLinkIcon className="ml-2 h-5 w-5" />
        </button>
      )}
    </div>
  );
}
export default FlowBuilderStepTriggerFlow;
